import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';

@Injectable({
  providedIn: 'root'
})
export class NativeSafeZoneService {
  public paddings = {
    top: 0,
    bottom: 0,
  }

  public constructor() {
    // Android handle safezone itself, iOS forces borderless view
    if(Capacitor.getPlatform() === 'ios') {
      SafeArea.getSafeAreaInsets().then(({ insets }) => {
        this.paddings.top = insets.top;
        this.paddings.bottom = insets.bottom;
      });
    }
  }
}
